<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
      </h4>
    </div>

    <div v-if="!loaded">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5">
              <select
                v-model="profileTypeFilter"
                class="form-control"
                required
              >
                <option value="ALL">
                  {{ $t('companyVendors.btnProfillr') }}
                </option>
                <option value="SUPPLIER">
                  {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                </option>
                <option value="LOGISTIC">
                  {{ $t('companyFormEdit.logistiklrN') }}
                </option>
                <option value="TRUCK">
                  {{ $t('companyFormEdit.trSahiblriN') }}
                </option>
              </select>
            </div>
            <div
              v-if="profileTypeFilter==='SUPPLIER' || profileTypeFilter ==='ALL'"
              class="col-md-7"
            >
              <select
                v-model.number="sectorFilter"
                class="form-control"
              >
                <option value="0">
                  {{ $t('companyVendors.btnSektorlar') }}
                </option>
                <option
                  v-for="s in sectorList"
                  :value="s.id"
                >
                  {{ s.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="list-group list-group-flush">
          <div
            v-if="filteredVendors.length<1"
            class="list-group-item"
          >
            <div v-if="sectorFilter>0 || profileTypeFilter !=='ALL'">
              {{ $t('companyVendors.axtraraUyunNticTaplmad') }}
            </div>
            <div v-else>
              {{ $t('companyVendors.tsdiqlnmiTdarkYoxdur') }}
            </div>
          </div>
          <div
            v-for="v in filteredVendors"
            class="list-group-item"
          >
            <div class="row">
              <div class="col-md-4 mb-3">
                <strong>{{ v.verifiedCompany.name }} {{ getCompanyFormat(v.verifiedCompany.format) }}</strong>
                <br>
                {{ $t('supplierOutgoingVendorRequest.ven') }} <em>{{ v.verifiedCompany.taxId }}</em>
              </div>
              <div class="col-md-8 mb-3">
                <div v-if="v.profileType==='LOGISTIC'">
                  {{ $t('companyVendors.logistikSorularNTsdiqlnmidir') }}
                </div>

                <div v-if="v.profileType==='TRUCK'">
                  {{ $t('companyVendors.trlarlaBalSorularNTsdiqlnmidir') }}
                </div>

                <div v-for="s in v.sectors">
                  <span :class="{'font-weight-bold': sectorFilter>0 && sectorFilter === s.sector.id}">
                    - {{ s.sector.name }}
                  </span>
                  <a
                    href="#"
                    @click.prevent="showRequestDetails(s.companyFormRequest.id)"
                  >
                    {{ $t('supplierOutgoingVendorRequest.mracit', {id: s.companyFormRequest.id}) }}
                  </a>
                </div>
              </div>
              <div class="col-md-12">
                 {{$t('companyVendors.vcreatedbynameVcreatedbysurnameTrfindnNewDatevlogt' , {name: v.createdBy.name  , surname : v.createdBy.surname })}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-vendor-request"
      size="xl"
      centered
      :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
    >
      <VendorRequestDetailsReceiver
        v-if="activeRequestId>0"
        :active-request-id="activeRequestId"
        @confirmRequest="confirmRequest($event)"
      />
    </b-modal>


    <b-modal
      id="modal-request-confirm"
      size="lg"
      centered
      :title="$t('companyFormAdminView.mracitinTsdiqlnmsi')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="getVendorList"
    >
      <ConfirmVendorRequestModal
        :confirm-request-details="confirmRequestDetails"
        @updated="showRequestDetails(confirmRequestDetails.requestId)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  getVendorList,
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import VendorRequestDetailsReceiver from "@/pages/scc/vendorManagement/VendorRequestDetailsReceiver.vue";
import ConfirmVendorRequestModal from "@/pages/scc/vendorManagement/ConfirmVendorRequestModal.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";


export default {
  components: {
    CompanyFormRequestStatus,
    ConfirmVendorRequestModal,
    VendorRequestDetailsReceiver,
    CompanyFormStatus
  },
  data() {
    return {
      mediaBase: mediaBase,
      loaded: false,
      vendors: [],
      form: null,
      sectors: [],
      sections: [],
      inputs: [],
      faq: [],
      faqAnswerText: '',
      formLink: '',

      requests: [],
      activeRequestId: 0,
      confirmRequestDetails: null,

      sectorFilter: 0,
      profileTypeFilter: 'ALL'

    }
  },
  watch:{
    "$route"(){
      this.sectorFilter = parseInt(this.$route.query['sectorId']||0);
      this.profileTypeFilter =  this.$route.query['profile']||'ALL';
    },
    profileTypeFilter(){
      if(this.profileTypeFilter!== 'SUPPLIER' && this.profileTypeFilter !== 'ALL' ){
        this.sectorFilter = 0;
      }
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    sectorList() {

      let map = {};

      this.vendors.forEach(v => {
        v.sectors.forEach(s => {
          map[s.sector.id] = s.sector;
        })
      })

      return Object.values(map);
    },

    filteredVendors() {

      let vendors = this.vendors;

      if (this.sectorFilter > 0) {
        vendors =  this.vendors.filter((v) => {
          return v.sectors.filter(s => {
            return s.sector.id === this.sectorFilter;
          }).length > 0
        });
      }
      if (this.profileTypeFilter !=='ALL') {
        vendors =  this.vendors.filter((v) => {
          return v.profileType === this.profileTypeFilter;
        });
      }

      return  vendors;

    }
  },
  mounted() {

    this.getVendorList();

    this.sectorFilter = parseInt(this.$route.query['sectorId']||0);
    this.profileTypeFilter =  this.$route.query['profile']||'ALL';
  },
  methods: {
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getVendorList() {

      getVendorList(this.token).then((list) => {
        this.loaded = true;
        this.vendors = list;
      });

    },


    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },

    confirmRequest(data) {
      this.confirmRequestDetails = data;
      this.$bvModal.hide('modal-vendor-request');
      this.$bvModal.show('modal-request-confirm')
    },


  }

}
</script>
